export const emo_template = {
  state: {
    emo_templates: []
  },
  mutations: {
    updateEmoTemplates: function(state, newList) {
      state.emo_templates = newList;
    }
  },
  getters: {
    getAllEmoTemplates(state) {
      return state.emo_templates;
    },
    getEmoTemplateByUUID(state) {
      return function(uuid) {
        return state.emo_templates.find(function(a) {
          return (a.uuid === uuid)
        })
      }
    }
  }
}